import ErrorScreen, { GlobalErrorScreen } from '@screens/app/error'
import { captureException } from '@sentry/react-native'
import { ErrorInfo, useCallback } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

export const GlobalErrorBoundary = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const onError = useCallback((e: Error, i: ErrorInfo) => {
    console.log('GlobalErrorBoundary', e, i)
    captureException(e, {
      tags: { location: 'GlobalErrorBoundary' },
      extra: {
        componentStack: i.componentStack,
        digest: i.digest,
      },
    })
  }, [])

  return (
    <ErrorBoundary onError={onError} FallbackComponent={GlobalErrorScreen}>
      {children}
    </ErrorBoundary>
  )
}

const AppErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const onError = useCallback((e: Error, i: ErrorInfo) => {
    console.log('AppErrorBoundary', e, i)
    captureException(e, {
      tags: { location: 'AppErrorBoundary' },
      extra: {
        componentStack: i.componentStack,
        digest: i.digest,
      },
    })
  }, [])

  return (
    <ErrorBoundary onError={onError} FallbackComponent={ErrorScreen}>
      {children}
    </ErrorBoundary>
  )
}

export default AppErrorBoundary
